module.exports = __webpack_public_path__ + "static/media/navidad17.8e6124ca.jpg";